import { useEffect, useState, useCallback } from "react";
import { useSearchParams } from "react-router-dom";
import api from "../lib/api";
import { ArticleCard } from "../components/ArticleCard";

export default function SearchPage() {
    const [params] = useSearchParams();
    const q = params.get("q") || "";
    const [items, setItems] = useState([]);
    const [total, setTotal] = useState(0);
    const [page, setPage] = useState(1);
    const [hasMore, setHasMore] = useState(false);
    const [loading, setLoading] = useState(true);

    const fetchPage = useCallback(async (p) => {
        const { data } = await api.get("/search", { params: { q, page: p, page_size: 12 } });
        return data;
    }, [q]);

    useEffect(() => {
        setLoading(true);
        setPage(1);
        fetchPage(1).then((data) => {
            setItems(data.items);
            setTotal(data.total);
            setHasMore(data.has_more);
        }).finally(() => setLoading(false));
    }, [q, fetchPage]);

    const loadMore = async () => {
        const next = page + 1;
        const data = await fetchPage(next);
        setItems((prev) => [...prev, ...data.items]);
        setPage(next);
        setHasMore(data.has_more);
    };

    return (
        <div className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-8 py-10" data-testid="search-page">
            <div className="border-b-2 border-ink pb-4 mb-8">
                <span className="font-mono text-xs uppercase tracking-widest text-accent">Search results</span>
                <h1 className="font-serif text-3xl sm:text-4xl font-black mt-1">
                    “{q}” <span className="font-mono text-base font-normal text-muted-foreground">— {total} result{total !== 1 ? "s" : ""}</span>
                </h1>
            </div>

            {loading ? (
                <p className="font-mono text-sm text-muted-foreground animate-pulse py-16 text-center">Searching…</p>
            ) : items.length === 0 ? (
                <p className="font-mono text-sm text-muted-foreground py-16 text-center" data-testid="search-empty">No articles matched your search.</p>
            ) : (
                <>
                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-12">
                        {items.map((a) => (
                            <ArticleCard key={a.id} article={a} />
                        ))}
                    </div>
                    {hasMore && (
                        <div className="mt-14 text-center">
                            <button onClick={loadMore} data-testid="search-load-more" className="px-10 py-3 border-2 border-ink font-mono text-xs uppercase tracking-widest hover:bg-ink hover:text-white transition-colors duration-150">
                                Load More
                            </button>
                        </div>
                    )}
                </>
            )}
        </div>
    );
}
